<template>
  <v-app class="grey lighten-5">
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-container>
      <v-row class="justify-center">
        <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
          <p>Carregando...</p>
          <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
        </div>
        <v-col class="col-12 col-md-10" v-if="!isLoading">
          <div class="d-flex flex-column flex-md-row align-center justify-space-between">
            <h2 class="text-center text-md-left primary--text ml-md-4">
              <v-icon class="primary--text mr-2">calendar_today</v-icon>Detalhe da Consulta
            </h2>
            <v-btn
              class="px-5"
              @click="notifyPsychologist()"
              target="_blank"
              color="primary"
              v-if="details.status == 'SCHEDULED' && details.dateTime <= nowDateTime"
            >
              <v-icon class="white--text mr-2">videocam</v-icon>
              Consulta
            </v-btn>
          </div>
          <p
            v-if="details.status == 'SCHEDULED' && details.dateTime >= nowDateTime"
            class="col-12 ml-md-2 gray--text"
          >
            O botão para a consulta estará disponível na data e horário da consulta marcada.
          </p>
          <div class="row justify-center">
            <div class="col-12 col-md-5">
              <div
                class="box-item custom-radius bg-yellow d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">record_voice_over</v-icon>
                  <p class="ma-0 mr-2 gray--text">
                    {{ details.psychologist.name }}
                  </p>
                </div>
                <v-btn class="bt-perfil" @click="goProfilePsi(details.psychologist.slug)"
                  >Ver Perfil</v-btn
                >
              </div>
              <div
                class="box-item border-bottom d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">calendar_today</v-icon>
                  <p class="ma-0 mr-2 gray--text">
                    {{ details.date | formatDate }}
                  </p>
                </div>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">access_time</v-icon>
                  <p class="ma-0 mr-2 gray--text">
                    {{ details.time | formatDateTZ(details.date, details.time) }}
                  </p>
                </div>
              </div>
              <div
                class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
                v-if="cupom"
              >
                <h3 class="ma-0 gray--text mr-1">Valores</h3>
                <div class="value_cupom d-flex flex-row align-center" style="margin-left: 20px">
                  <img :src="require('../../assets/cashBag.svg')" width="28px" />
                  <div style="margin-left: 20px">
                    <p class="ma-0 gray--text mr-1">
                      Valor:<span class="ma-0 secondary--text">{{ value }}</span>
                    </p>
                    <p class="ma-0 gray--text mr-1">
                      {{ $t('queryDetail.coupon') }} ({{ cupom }}%):<span class="ma-0 secondary--text">
                        -{{ discountValue | currency }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
                v-if="
                  !details.with_chief_therapist ||
                  (details.with_chief_therapist && details.is_first)
                "
              >
                <p class="ma-0 mr-2 gray--text">
                  <strong>Valor da Consulta:</strong>
                </p>
                <p class="ma-0 mr-2 secondary--text valor-consulta">
                  {{ finalValue }}
                </p>
              </div>
              <DetailMultbanck
                :entity="entity"
                :reference="reference"
                @copy="okcopy"
                class="bg-gray"
                v-if="paymentType === 'multibanco'"
              />
              <div
                class="bg-yellow font-weight-medium f-12 custom-radius justify-center d-flex text-center mt-2 py-3"
                v-if="paymentStatus"
              >
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-if="paymentStatus === 'APPROVED'"
                >
                  Status de pagamento: <span class="secondary--text">Aprovado</span>
                </p>
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-if="paymentStatus === 'PENDING'"
                >
                  Status de pagamento: <span class="gray--text">Pendente</span>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <p class="ma-0 mr-2 gray--text text-center text-md-left">
                <strong>{{ $t('pageConsulta.titleContato') }}</strong>
              </p>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4"
              >
                <p class="ma-0 gray--text">
                  <strong>Email</strong>
                </p>
                <v-icon class="gray--text ml-2" size="30">email</v-icon>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{ details.psychologist.email }}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-center align-center">
            <!-- REAGENDAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && details.date > date"
            >
              <v-row justify="center">
                <v-btn
                  @click="reschedule"
                  color="gray"
                  v-on="on"
                  class="white--text"
                  height="50"
                  min-width="100%"
                >
                  Reagendar
                </v-btn>
                <v-dialog v-model="dialog" max-width="400">
                  <v-card>
                    <v-card-title class="headline">Reagendar consulta!</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        <p>Informe aqui o motivo do reagendamento.</p>
                        <v-textarea
                          solo
                          no-resize
                          background-color="#F7F7F7"
                          rows="8"
                          v-model="justification"
                        ></v-textarea>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                      <!-- <v-btn color="gray darken-1" text @click="dialog = false">Não Obrigado</v-btn> -->
                      <v-btn
                        color="primary darken-1"
                        text
                        :loading="isLoading"
                        :disabled="isDisabled"
                        @click="rescheduleConsultation()"
                        >Ok</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
            <!-- <div
              class="col-12 col-md-3 text-center"
              v-if="details.date >= date && details.time > time"
            >
              <v-btn color="primary" height="50" min-width="100%">Cancelar</v-btn>
            </div> -->
            <!-- FINALIZAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && details.dateTime <= nowDateTime"
            >
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                color="primary"
                height="50"
                min-width="100%"
                @click="doneConsultation()"
                >Finalizar</v-btn
              >
            </div>
            <!-- Avaliar  -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'CLOSED' && details.assessment == null"
            >
              <v-row justify="center">
                <v-dialog v-model="dialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" dark v-on="on" height="50" min-width="100%"
                      >Avaliar</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title class="headline">Avaliar atendimento!</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        Avalie aqui o seu atendimento.
                        <v-rating
                          v-model="rating"
                          color="red lighten-2"
                          background-color="gray lighten-1"
                          hover
                          class="my-3"
                        ></v-rating>
                        <p v-if="isInvalid" class="red--text">Defina uma quantidade de estrelas.</p>
                        <v-textarea
                          solo
                          no-resize
                          background-color="#F7F7F7"
                          rows="8"
                          v-model="comments"
                        ></v-textarea>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-space-between">
                      <v-btn color="gray darken-1" text @click="dialog = false">Não Obrigado</v-btn>

                      <v-btn color="primary darken-1" text @click="evaluate()">Avaliar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
            <div class="col-12 col-md-3 text-center" v-if="details.status == 'CANCELLED'">
              <div class="grey white--text px-4 py-3">
                <p class="ma-0 font-weight-bold">Consulta cancelada.</p>
                <p class="ma-0 mt-3 text-left">Motivo: {{ details.closing.comments }}</p>
              </div>
            </div>
          </div>
        </v-col>
        <AlertScheduleSepa ref="alertScheduleSepa" @ok="alertSepaOK" />
        <AlertScheduleMultbank ref="alertScheduleMultbank" @close="alertMultibankOK" />
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import momentTimezone from 'moment-timezone';
import DetailMultbanck from '@/components/PaymentMethods/DetailMultbanck.vue';
import AlertScheduleSepa from '@/components/AlertScheduleSepa.vue';
import AlertScheduleMultbank from '@/components/AlertScheduleMultbank.vue';

import generalService from '../../services/general';
import Api from '../../services/httpClient';

export default {
  components: {
    DetailMultbanck,
    AlertScheduleSepa,
    AlertScheduleMultbank,
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: new Date().toTimeString().substr(0, 8),
      nowDateTime: new Date().toISOString().substr(0, 19),
      cod: '',
      details: {
        assessment: {},
        date: String,
        id: String,
        patient: String,
        patient_name: String,
        psychologist: {},
        status: String,
        time: String,
      },
      value: '',
      isLoading: false,
      dialog: false,
      rating: 0,
      comments: '',
      justification: '',
      paymentStatus: '',
      paymentType: '',
      isInvalid: false,
      isDisabled: true,
      snackbar: false,
      msg: '',
      firstAppointment: null,
      cupom: '',
      discountValue: '',
      finalValue: '',
      entity: '',
    };
  },
  async created() {
    await this.getCod();
    await this.getDetails();
    await this.verifyTherapistAppointments();
  },
  watch: {
    rating(val) {
      if (val > 0) {
        this.isInvalid = false;
      }
    },
    justification(val) {
      val ? (this.isDisabled = false) : (this.isDisabled = true);
    },
  },
  methods: {
    okcopy() {
      this.snackbar = true;
      this.msg = 'Código Multibanco foi copiado com sucesso!';
      navigator.clipboard.writeText(`Entidade: ${this.entity} Referência: ${this.reference}`);
    },
    alertSepaOK() {
      this.dialog = true;
    },
    alertMultibankOK() {
      this.dialog = true;
    },
    reschedule() {
      if (this.paymentType === 'credit_card') {
        this.dialog = true;
        return;
      }
      if (this.paymentType === 'multibanco') {
        const { alertScheduleMultbank } = this.$refs;
        if (!alertScheduleMultbank) return;

        alertScheduleMultbank.openDialog();
        return;
      }

      const { alertScheduleSepa } = this.$refs;
      if (!alertScheduleSepa) return;

      alertScheduleSepa.openDialog();
    },
    createPayment() {
      // No dia e horário da consulta o link para a vídeo chamada será disponibilizada no detalhe da sua consulta.
      if (!window.confirm('O valor da consulta será pré-reservado no limite do seu cartão.'))
        return;

      this.isLoading = true;
      Api.post('/create_payment/', { appointmentId: this.details.id })
        .then((response) => {
          if (response.status === 200) {
            window.location.href = `https://meet.jit.si/ondivan-consulta-${this.details.id}`;
          }
        })
        .catch((error) => {
          alert('Pagamento não autorizado.');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async notifyPsychologist() {
      await Api.post('/create_payment/', {
        appointmentId: this.details.id,
      });
      this.$router.replace(
        `/paciente/meeting/${this.details.id}/ondivan-${this.details.psychologist.id}-${this.details.patient}`,
      );
    },
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async verifyTherapistAppointments() {
      const res = await generalService.getFirstAppointments();
      if (res.data === '') {
        this.firstAppointment = null;
      } else {
        this.firstAppointment = res.data;
      }
    },
    getDetails() {
      this.isLoading = true;
      const { id } = this.$route.params;
      Api.get(`/patients/${this.cod}/appointments/${id}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => {
          const { data } = response;
          this.details = data;
          if (data.payment_method_type === 'multibanco') {
            this.entity = data.multibanco.entity;
            this.reference = data.multibanco.reference;
          }
          this.paymentType = data.payment_method_type;
          this.paymentStatus = data.status_payment;
          this.cupom = data.coupon_value;
          this.discountValue = data.discount_coupon_value;
          this.value =
            data.psychologist.appointment_br_value == '0.00'
              ? `€ ${data.psychologist.appointment_pt_value}`
              : `R$ ${data.psychologist.appointment_br_value}`;
          if (this.cupom) {
            this.finalValue = this.value.split(' ');
            this.finalValue = `${this.finalValue[0]} ${this.finalValue[1] - this.discountValue}`;
          } else {
            this.finalValue = this.value;
          }
          this.details.dateTime = data.date.concat('T', data.time);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    goProfilePsi(id) {
      this.$router.push({ name: 'PsicologoProfile', params: { id } });
    },
    doneConsultation() {
      this.isLoading = true;
      Api.post(
        `/patients/${this.cod}/appointments/${this.details.id}/closing/`,
        {},
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    rescheduleConsultation() {
      this.isDisabled = true;
      Api.post(
        `/patients/${this.cod}/appointments/${this.details.id}/cancellation/`,
        {
          comments: this.justification,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          this.isDisabled = false;
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
            this.$router.replace(`/psicologo/scheduling/${this.details.psychologist.id}`);
          }
        })
        .catch((error) => {
          this.isDisabled = false;
          console.log(error);
        });
    },
    async evaluate() {
      if (this.rating == 0) {
        this.isInvalid = true;
        return;
      }
      await Api.post(
        `/patients/${this.cod}/appointments/${this.details.id}/assessment/`,
        {
          rating: this.rating,
          comments: this.comments,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            console.log(data);
            this.details = data;
            this.snackbar = true;
            this.msg = 'Avaliação enviada com sucesso!';
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.dialog = false;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.container-clipBoard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
}
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.box-item {
  width: 100%;
}

.custom-radius {
  border-radius: 5px;
}

.bg-yellow {
  background-color: #fffde3;
}

.bg-gray {
  background-color: #e0e0e0 !important;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.bt-perfil {
  font-size: 0.5rem;
}

.obs-text {
  font-size: 0.8rem;
}

.valor-consulta {
  font-size: 1.3rem;
}

.whats-img,
.whats-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.skype-img,
.skype-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.email-img,
.email-img .v-image__image--cover {
  width: 30px;
  height: 30px;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
